import { acceptLanguage } from '~/i18n.config';

export function useSlug() {
  /**
   * Transform an object with slugFR, slugIT, etc., into an object with keys fr, it, en, and de.
   *
   * @param {Object} inputObject - The input object containing slug fields.
   * @returns {Object} - The transformed object with localized keys.
   */
  function transformSlugsForSeo(inputObject) {
    const locales = acceptLanguage;
    return Object.fromEntries(locales.map((locale) => [locale, inputObject?.[`slug${locale.toUpperCase()}`] ?? '']));
  }

  return { transformSlugsForSeo };
}
